/**
 * Validation Utilities
 * Provides validation functions for user inputs and data
 */

/**
 * Validate intention text
 * Must be between 1 and 500 characters, not empty or only whitespace
 */
export function validateIntentionText(text: string): { valid: boolean; error?: string } {
  if (!text || text.trim().length === 0) {
    return { valid: false, error: 'Intention cannot be empty' };
  }

  if (text.length < 1) {
    return { valid: false, error: 'Intention must be at least 1 character' };
  }

  if (text.length > 500) {
    return { valid: false, error: 'Intention must be 500 characters or less' };
  }

  return { valid: true };
}

/**
 * Validate that at least one intention is provided
 */
export function validateAtLeastOneIntention(intentions: unknown[]): { valid: boolean; error?: string } {
  if (!intentions || intentions.length === 0) {
    return { valid: false, error: 'At least one intention is required' };
  }

  return { valid: true };
}

/**
 * Validate date
 */
export function validateDate(date: Date | string): { valid: boolean; error?: string } {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) {
    return { valid: false, error: 'Invalid date' };
  }

  return { valid: true };
}

/**
 * Validate birth date (must be in the past)
 */
export function validateBirthDate(date: Date | string): { valid: boolean; error?: string } {
  const dateValidation = validateDate(date);
  if (!dateValidation.valid) {
    return dateValidation;
  }

  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const now = new Date();

  if (dateObj >= now) {
    return { valid: false, error: 'Birth date must be in the past' };
  }

  return { valid: true };
}
